module.exports = __webpack_public_path__ + "img/clean-water-and-sanitation.c5bc6547.png";